import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <Loader2 className="animate-spin text-ally-pink" size={36} />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

export const RoleRoute = ({ roles, children, fallback = "/enterprise/login" }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <Loader2 className="animate-spin text-ally-pink" size={36} />
      </div>
    );
  if (!user) return <Navigate to={fallback} replace />;
  if (!roles.includes(user.role)) {
    const home = (user.role === "superadmin" || user.role === "support" || user.role === "support_viewer") ? "/admin" : user.role === "enterprise" ? "/enterprise/app" : user.role === "client" ? "/client" : "/dashboard";
    return <Navigate to={home} replace />;
  }
  return children;
};
